// Opening an <el-select> dropdown (<el-options> popover) makes iOS Safari
// jump to the top of the page. Save the scroll position right before the
// popover opens and restore it just after. Capture phase: popover toggle
// events don't bubble, and delegation also covers el-selects added
// dynamically (nested-form) or after a Turbo visit.
// Works together with the iOS `html { overflow: visible !important }` rule in
// application.css — without it the library's scroll lock would clamp the page
// and make the restore a no-op.
let savedY = 0

document.addEventListener(
  "beforetoggle",
  (e) => {
    if (e.target.tagName === "EL-OPTIONS" && e.newState === "open") savedY = window.scrollY
  },
  true
)

document.addEventListener(
  "toggle",
  (e) => {
    if (e.target.tagName === "EL-OPTIONS" && e.newState === "open") {
      requestAnimationFrame(() => {
        if (window.scrollY !== savedY) window.scrollTo({top: savedY, behavior: "instant"})
      })
    }
  },
  true
)
